import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: [
      "en",
      "fr",
      "es",
      "eu",
      "hu",
      "nl",
      "pl",
      "pt",
      "de",
      "ja",
      "co",
    ],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: ["translation", "rules"],
    defaultNS: "translation",
  });

export default i18n;
